import React from 'react';
import { useSelector } from 'react-redux';

import { localPreferences } from 'app-components/utils/core';

import Snackbar from '@mui/material/Snackbar';
import type { SnackbarOrigin } from '@mui/material/Snackbar';

import * as appSelectors from 'data/app/selectors';

const anchorOrigin: SnackbarOrigin = { vertical: 'bottom', horizontal: 'right' };

const OfflineSnackbar = () => {
  const isOffline = useSelector(appSelectors.getIsOffline);
  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={isOffline && localPreferences.getOfflineSupport()}
      message='Offline Mode'
    />
  );
};

export default OfflineSnackbar;
